import {
  collection,
  CollectionReference,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IApiKey, IUser } from '../types';
import { authenticatedUserProvider } from './userProvider';

export default (): Observable<IApiKey[]> => {
  return authenticatedUserProvider().pipe(
    switchMap((user: IUser): Observable<IApiKey[]> => {
      return collectionData(
        query(
          collection(
            user.services.firestore,
            'apiKeys'
          ) as CollectionReference<IApiKey>,
          where('orgId', '==', user.orgId),
          orderBy('expiresAt', 'desc')
        ),
        { idField: 'id' }
      );
    })
  );
};
